import { render, staticRenderFns } from "./EditPhilosophy.vue?vue&type=template&id=61fd6592&scoped=true&"
import script from "./EditPhilosophy.vue?vue&type=script&lang=js&"
export * from "./EditPhilosophy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fd6592",
  null
  
)

export default component.exports